console.log = () => {};
console.info = () => {};
console.debug = () => {};
console.warn = () => {};
console.error = () => {};
console.table = () => {};
console.group = () => {};
console.groupEnd = () => {};
console.groupCollapsed = () => {};
console.trace = () => {};
console.time = () => {};
console.timeEnd = () => {};

import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import { AuthProvider } from './contexts/AuthContext.jsx'
import 'bootstrap/dist/css/bootstrap.min.css'
import './index.css'

// Глобальный обработчик ошибок для предотвращения краха приложения
const ErrorBoundary = ({ children }) => {
  React.useEffect(() => {
    const handleError = (event) => {
      console.error('Global error caught:', event.error);
      // Предотвращаем падение приложения
      event.preventDefault();
    };

    const handleUnhandledRejection = (event) => {
      console.error('Unhandled promise rejection:', event.reason);
      // Предотвращаем падение приложения
      event.preventDefault();
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);

  return children;
};
// Глобальные стили для toast уведомлений
const addNotificationStyles = () => {
  const style = document.createElement('style');
  style.textContent = `
    .notification-toast {
      animation: slideInRight 0.3s ease-out;
    }
    
    @keyframes slideInRight {
      from {
        transform: translateX(100%);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }
    
    .notification-toast.fade-out {
      animation: slideOutRight 0.3s ease-in;
    }
    
    @keyframes slideOutRight {
      from {
        transform: translateX(0);
        opacity: 1;
      }
      to {
        transform: translateX(100%);
        opacity: 0;
      }
    }
  `;
  document.head.appendChild(style);
};

// Глобальный обработчик для предотвращения обновления страницы при ошибках форм
const handleFormErrors = () => {
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (form && form.method === 'post') {
      // Для форм с методом POST предотвращаем стандартное поведение
      e.preventDefault();
    }
  });
};

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ErrorBoundary>
  </React.StrictMode>,
)

// Инициализация после рендера
setTimeout(() => {
  handleFormErrors();
  addNotificationStyles();
}, 100);